/* RESPONSIBLE TEAM: team-standalone */

import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import type ZendeskTicketsTestController from 'embercom/controllers/apps/app/standalone/deploy/zendesk/tickets/test';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';

export default class Test extends Route {
  @service declare finStandaloneService: FinStandaloneService;

  queryParams = {
    section: {
      refreshModel: false,
    },
  };

  setupController(
    controller: ZendeskTicketsTestController,
    model: unknown,
    transition: Transition,
  ) {
    super.setupController(controller, model, transition);

    let params = this.paramsFor(this.routeName) as { section: string };

    if (params.section) {
      controller.set('section', params.section);
    } else {
      controller.set('section', this.openSectionId);
    }
  }

  resetController(
    controller: ZendeskTicketsTestController,
    isExiting: boolean,
    transition: Transition,
  ) {
    super.resetController(controller, isExiting, transition);
    if (isExiting) {
      controller.set('section', null);
    }
  }

  get openSectionId() {
    if (!this.finStandaloneService.hasContentForFin) {
      return 'fin-ready';
    }

    if (!this.zendeskConfig.isPendingSetupForTickets) {
      return 'test-fin';
    }

    return null;
  }

  get zendeskConfig() {
    return this.finStandaloneService.zendeskConfig!;
  }
}
